// redux/slices/googleAuthSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '../../services/authApi';
import handleAsyncThunk from '../handleAsyncThunk';
import { logMeIn } from './userSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';

export const googleAuth = createAsyncThunk(
  'auth/googleAuth',
  async (token, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState();
      const { isSignedIn } = state.user;

      if(isSignedIn) {
        dispatch(showErrorSnackbar({ title: 'Already Signed In' }));
        rejectWithValue('Already signed in');
        return
      }
      const response = await authApi.googleAuth({ token });

      if (response.status === 0) { // the API returns status 0 for success
        if (response.data?.token) {
          dispatch(logMeIn({ user: response.data, token: response.data.token }));
        }

        dispatch(showSuccessSnackbar({ title: response.data.message }));
        return response.data; // Return the response data on success
      } else {
        dispatch(showErrorSnackbar({ title: response.message }));
        return rejectWithValue(response.message); // Reject with error message
      }
    } catch (error) {
      console.error(error);
      dispatch(showErrorSnackbar({ title: error.message }));
      return rejectWithValue(error.message); // Handle unexpected errors
    }
  }
);


const googleAuthSlice = createSlice({
  name: 'googleAuth',
  initialState: {
    user: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    handleAsyncThunk(builder, googleAuth, 'user', 'error', 'loggingWithGoogle');
   },
});

export default googleAuthSlice.reducer;
